import React from "react";
import { Form } from "react-bootstrap";
import styles from "./CheckboxFormField.module.scss";

// Extend the base FormField props, but make some properties optional
// that don't make sense for checkboxes
interface CheckboxFormFieldProps {
  label: string;
  helpText?: string;
  name: string;
  checked?: boolean;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  validated?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  id?: string;
}

const CheckboxFormField: React.FC<CheckboxFormFieldProps> = ({
  label,
  helpText,
  name,
  checked = false,
  error = false,
  errorMessage,
  disabled = false,
  validated = false,
  onChange,
  className,
  id,
}) => (
  <Form.Group className={className}>
    <div className={`flex items-center ${styles.formGroup}`}>
      <Form.Check
        id={id || name}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        isInvalid={error && validated}
        isValid={!error && validated}
        label={<span data-variant="label-2-bold">{label}</span>}
      />
    </div>
    {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
    {error && validated && (
      <div className="invalid-feedback d-block">
        {errorMessage || `Invalid ${label.toLowerCase()}`}
      </div>
    )}
  </Form.Group>
);

export default CheckboxFormField;
